import { useQuery } from '@tanstack/react-query'
import { equipmentApi } from '@/api/equipmentApi'
import { useEquipmentScope } from '@/components/equipment/equipmentScope'
import { useTenant } from '@/providers/TenantProvider'

/** Query key root, so a task's End or a run's progress can refresh the list. */
export const PENDING_ACTIONS_KEY = 'pending-actions'

/**
 * The page's tasks waiting on their cycle's procedure (z8nrz7ewt1): rooms on
 * Cleaning, equipment on Equipment — the scope's purposes, like every other
 * query on the page. `assigneeId` narrows to one person's (the Resource filter).
 */
export function usePendingActions(enabled = true, assigneeId: string | null = null) {
  const { selectedTenantId: tenantId } = useTenant()
  const { purposes } = useEquipmentScope()
  return useQuery({
    queryKey: [PENDING_ACTIONS_KEY, tenantId, purposes, assigneeId],
    enabled: enabled && !!tenantId,
    // Fresh on every visit: the list changes on the run page (forms done) and
    // on Tasks (End), and coming back to stale progress would misreport both.
    staleTime: 0,
    queryFn: () => equipmentApi.listPendingActions(tenantId as string, purposes, assigneeId),
  })
}
